export default {
  primaryBlue: "#0448A3",
  secondaryBlue: "#2D9CDB",
};
